import type { PatientCreationStep_Patient } from '../../../types';
import type { PatientFormType } from './validation';

export const mapNewPatientForm = (
  data: PatientFormType,
): PatientCreationStep_Patient => {
  // Profile is stored separately; a new-patient choice must not reuse a selected patient ID.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { organizationProfile, patientReferenceId, ...rest } = data;

  return {
    ...rest,
    ...(patientReferenceId?.trim() ? { patientReferenceId } : {}),
    id: undefined,
    middleName: rest.middleName?.trim() || undefined,
    address: {
      ...rest.address,
      state: rest.address.state?.trim() || undefined,
    },
  };
};
